// var $window = $(window);

// メニューon/off
$('.js-header-pop-open').click(function(){
    var $target = $('.js-header-pop-target');
    var status = $target.attr('data-sp-menu');
    var $body = $('body');

    $target.attr('data-sp-menu', status!=='open' ? 'open' : 'close');
    $(this).attr('data-sp-menu', status!=='open' ? 'open' : 'close');
    $('body').toggleClass('is-popup');

    // 現在のスクロール座標を記録・復元
    if( $target.attr('data-sp-menu') === 'open' ){
    	var scroll = $('body').scrollTop();
    	$body.attr('data-scroll', scroll)
        // $body
	    .attr('data-sp-menu', 'open')
    	.css({top: -scroll});


    }else{
	    $body.attr('data-sp-menu', 'close')
    	.scrollTop( $body.attr('data-scroll') )
    	.css({top: 0});
    }

    return false;
});


// スマホのサイドメニューオープン
$('.js-sidemenu-open-btn').on('click',function(){
    var $parent = $(this).parent();
    if( $parent.attr('data-menu-open') == 'true' ){
        $parent.attr('data-menu-open', 'false');
    }else{
        $parent.attr('data-menu-open', 'true');
    }
    return false;
});


// $('.js-menu-open-target a').click(function(event) {
//     var $target = $('.js-menu-open-target');
//     $target.removeClass('header__content_open');
//     $target.addClass('header__content_close');
// });

// トップページのメニュー位置調整
// if( $('#page-home').length && !$('body').hasClass('isMobile') ){
//     var $header = $('.visual .header');
//     var $visual = $('.visual');

//     function set_mainmenu_position(){
//         var visual_bottom = $visual.offset().top +  $visual.height();
//         var win_bottom = $window.scrollTop() + $window.height();

//         if( visual_bottom > win_bottom ){
//             $header.css({position:'fixed'});
//         }else{
//             $header.css({position:'absolute'});
//         }
//     }
//     $.throttle( 100, set_mainmenu_position );
//     set_mainmenu_position();
// }

